import {Directive, ElementRef, EventEmitter, Output, Input, OnDestroy, Renderer2, AfterViewInit} from '@angular/core';
import Pikaday from 'pikaday';

declare var jQuery: any;
declare var moment: any;

@Directive({
  selector: '[custom-datepicker]',
  standalone: true
})

export class CustomDatepicker implements AfterViewInit, OnDestroy{
  picker: any;
  dateFormat: any;
  fmt: string;
  minDate: any = new Date();
  maxDate: any;
  private removeKeyupListener!: () => void;
  @Output() valueChanged = new EventEmitter<any>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnDestroy(){
    if (this.picker){
      this.picker.destroy();
    }
     if (this.removeKeyupListener) {
      this.removeKeyupListener();
    }
  }

  @Input() set format(_format: string){
    this.fmt = _format;
  }

  @Input() set mindate(_mindate: string){
    if (_mindate == 'past'){
      this.minDate = null;
    } else if (moment(_mindate, 'MM/DD/YYYY', true).isValid()){
      this.minDate = new Date(_mindate);
    }
  }

  @Input() set maxdate(_maxDate: string){
    this.maxDate = new Date(_maxDate);
  }

  ngAfterViewInit() {
    const elem = this.el.nativeElement;
    // Always initialize on focus
    elem.addEventListener('focus', () => {
      // Destroy old picker if exists (prevents stale instance)
      if (this.picker) {
        this.picker.destroy();
        this.picker = null;
      }

      // Initialize new picker
      this.initPicker();

      // Show the picker immediately
      this.picker.show();
    });
  }

  private initPicker() {
     const base = this;
    const elem = this.el.nativeElement;
    this.picker = new Pikaday({ field: elem, format: this.fmt ? this.fmt : 'MM/DD/YYYY', minDate: this.minDate, maxDate: this.maxDate ? this.maxDate : 'past', firstDay : 1,
      onSelect(date) {
        const dt = base.picker.toString(base.fmt || '');
        elem.value = dt;
        base.valueChanged.emit(dt as any);
      }
    });
    
    this.removeKeyupListener = this.renderer.listen(elem, 'keyup', () => {
      const val: string = elem.value.trim();

      if (!val) {
        this.picker.setDate(null, true);
        this.valueChanged.emit('');
        return;
      }

      if (!moment(val, this.format, true).isValid()) {
        return; 
      }

      const typedDate = moment(val, this.format).toDate();
      this.picker.setDate(typedDate, true);
      this.valueChanged.emit(val);
    });
  }
}
